module.exports = __webpack_public_path__ + "img/左边图.a3acdc06.png";